import React from 'react';
import {CountryList} from "components/country/CountryList";
import {Provider} from "components/country/CountryContext";

export const Countries = () => {

    return (
        <Provider>
            <CountryList/>
        </Provider>
    );
}
